import logo from './logo.svg';

import './App.css';
import './Sidebar.css';
import './theme/theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AdminLogin from './admin/components/AdminLogin';
import AdminDashboard from './admin/components/AdminDashboard';
import AdminSchemas from './admin/components/AdminSchemas';
import AdminSchemaConfig from './admin/components/AdminSchemaConfig';
import AdminCompanyDetail from './admin/components/AdminCompanyDetail';
import AdminPricebooks from './admin/components/AdminPricebooks';
import AdminPricebookDetail from './admin/components/AdminPricebookDetail';
import AdminLicenseTypes from './admin/components/AdminLicenseTypes';
import AdminPlans from './admin/components/AdminPlans';
import AdminPlanConfig from './admin/components/AdminPlanConfig';
import AdminPlanLicenses from './admin/components/AdminPlanLicenses';
import AdminPlanDetail from './admin/components/AdminPlanDetail';
import Home from './components/Home';
import { AccordionCollapse, Container } from 'react-bootstrap';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import React, { useEffect, useState, useRef } from 'react';
import Alert from 'react-bootstrap/Alert';

import LeadList from './components/LeadList';
import LeadView from './components/LeadView';
import LeadEdit from './components/LeadEdit';

import AccountList from './components/AccountList';
import AccountView from './components/AccountView';
import AccountEdit from './components/AccountEdit';
import ContactList from './components/ContactList';
import ContactView from './components/ContactView';
import ContactEdit from './components/ContactEdit';
import ContactCreate from './components/ContactCreate';

import MiniSidebar from './components/MiniSidebar';
import * as constants from './constants/CONSTANT';
import ChangePassword from './components/ChangePassword';
import GoogleCalendarSync from './components/GoogleCalendarSync';
import GoogleAuthCallback from './components/GoogleAuthCallback';
import ReportView from './components/ReportView';
import ReportList from './components/ReportList';
import CalendarComponent from './components/calendar/Calendar';
import ReportBuilder from './components/reports/ReportBuilder';
import ReportBuilderPage from './components/reports/ReportBuilderPage';
import ReportEdit from './components/ReportEdit';

import PubSub from 'pubsub-js';
import { Toast, ToastContainer } from 'react-bootstrap';
import UserList from './components/UserList';
import UserEdit from './components/UserEdit';
import UserView from './components/UserView';
import UserProfile from './components/UserProfile';
import ProfileEdit from './components/ProfileEdit';
import UserPreferences from './components/UserPreferences';
import UserTracking from './components/UserTracking';
import BusinessList from './components/BusinessList';
import BusinessView from './components/BusinessView';
import BusinessEdit from './components/BusinessEdit';
import Notification from './components/Notification';
import BackupList from './components/BackupList';
import jwt_decode from 'jwt-decode';
import authApi from './api/authApi';
import io from 'socket.io-client';
import Main from './components/layout/Main';
import ProductList from './components/ProductList';
import ProductEdit from './components/ProductEdit';
import ProductView from './components/ProductView';
import PricebookEdit from './components/PricebookEdit';
import IncidentList from './components/IncidentList';
import IncidentView from './components/IncidentView';
import IncidentEdit from './components/IncidentEdit';
import DashboardList from './components/DashboardList';
import Dashboard from './components/Dashboard';
import DashboardView from './components/DashboardView';
import DashboardEdit from './components/DashboardEdit';
import WhatsAppSetting from './components/watconnect/whatsapp_setting/WhatsAppSetting';
import Templates from './components/watconnect/whatsapp_template/Templates';
import TemplateAdd from './components/watconnect/whatsapp_template/TemplateAdd';
import TemplatePreview from './components/watconnect/whatsapp_template/TemplatePreview';
import Templateview from './components/watconnect/whatsapp_template/TemplateView';
import WhatsAppChat from './components/watconnect/whatsapp_messenger/WhatsAppChat';
import WhatsAppMessenger from './components/watconnect/whatsapp_messenger/WhatsAppMessenger';
import Campaign from './components/watconnect/campaign/Campaign';
import CampaignEdit from './components/watconnect/campaign/CampaignEdit';
import CampaignAdd from './components/watconnect/campaign/CampaignAdd';
import CampaignView from './components/watconnect/campaign/CampaignView';
import CampaignTracking from './components/watconnect/campaign/CampaignTracking';
import Groups from './components/watconnect/groups/Groups';
import ResponseMessage from './components/watconnect/response_message/ResponseMessage';
import Invoices from './components/watconnect/invoices/Invoices';
import ProtectedRoute from './components/common/ProtectedRoute';
import PermissionProtectedRoute from './components/common/PermissionProtectedRoute';
import Billing from './Billing';
import GroupView from './components/watconnect/groups/GroupView';
import Module from './components/watconnect/module/Module';
import Plan from './components/watconnect/plan/Plan';
import CreatePlan from './components/watconnect/plan/CreatePlan';
import Addon from './components/watconnect/addon/Addon';
import CreateAddon from './components/watconnect/addon/CreateAddon';
import CompanyList from './components/watconnect/company/CompanyList';
import CreateCompany from './components/watconnect/company/CreateCompany';
import CompanyView from './components/watconnect/company/CompanyView';
import MyWallet from './components/watconnect/wallet/MyWallet';
import AddInvoice from './components/watconnect/invoices/AddInvoice';
import InvoiceView from './components/watconnect/invoices/InvoiceView';
import InvoiceLineItem from './components/watconnect/invoices/InvoiceLineItem';
import TagList from './components/watconnect/tags/TagList';
import WorkflowEditForm from './components/workflow/WorkflowEdit';
import WorkflowList from './components/workflow/WorkflowList';
import DetailView from './components/views/DetailView';
import EditView from './components/views/EditView';
import ListView from './components/views/ListView';
import ObjectManager from './components/objectmanager/ObjectManager';
import ActionManager from './components/objectmanager/ActionManager';
import RoleManager from './components/RoleManager';
import MenuPage from './components/MenuPage';
import SearchViewLayout from './components/search/SearchViewLayout';
import SearchViewManager from './components/setup/searchview/SearchViewManager';
import {
  PermissionList,
  PermissionEdit,
  PermissionBulkEdit,
} from './components/permissions';
import TabManagerRoute from './components/tabs/TabManagerRoute';
import AppManager from './components/setup/appmanager/AppManager';
import SetupWrapper from './components/setup/SetupWrapper';
import ScoringRuleManager from './components/setup/scoringrule/ScoringRuleManager';
import UserGroupManager from './components/setup/usergroups/UserGroupManager';
import AssignmentRuleManager from './components/setup/assignmentrule/AssignmentRuleManager';
import WebFormManager from './components/setup/webform/WebFormManager';
import SessionSettingManager from './components/setup/session_setting/SessionSettingManager';
import CurrencyManager from './components/setup/currency/CurrencyManager';
import CurrencyMasterManager from './components/setup/currency/CurrencyMasterManager';
import SystemSettingsManager from './components/setup/system_settings/SystemSettingsManager';
import StageMasterManager from './components/setup/stage_master/StageMasterManager';
import TelecmiSettingsManager from './components/setup/telecmi/TelecmiSettingsManager';
import {
  SetupUserList,
  SetupUserView,
  SetupUserEdit,
  RedirectUserList,
  RedirectUserView,
  RedirectUserEdit,
} from './components/setup/users/SetupUserViews';
import {
  SetupMailConfigList,
  SetupMailConfigView,
  SetupMailConfigEdit,
  RedirectMailConfigList,
  RedirectMailConfigView,
  RedirectMailConfigEdit,
} from './components/setup/mailconfig/SetupMailConfigViews';
import {
  SetupEmailTemplateList,
  SetupEmailTemplateView,
  SetupEmailTemplateEdit,
  RedirectEmailTemplateList,
  RedirectEmailTemplateView,
  RedirectEmailTemplateEdit,
} from './components/setup/emailtemplate/SetupEmailTemplateViews';
import ReportsListPage from './components/reports/ReportsListPage';
import ReportViewer from './components/reports/ReportViewer';
import DashboardManager from './components/dashboard/DashboardManager';
import WidgetManager from './components/dashboard/WidgetManager';
import DashboardCanvas from './components/dashboard/DashboardCanvas';
import HomeWidgetBuilder from './components/home/HomeWidgetBuilder';
import { ChatBotFlowList, AddChatBot } from './components/chatbot';
import { v4 as uuidv4 } from 'uuid';
import HomeWidget from './components/home/HomeWidget';
import ResetPassword from './components/ResetPassword';
import { AccessDenied, NotFound } from './components/errors';
import BulkEmailForm from './components/email/BulkEmailForm';

// changes check
function App() {
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState('Confirmation');
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [permissions, setPermissions] = useState();
  const [connectedSocket, setConnectedSocket] = useState();
  /** Spark backend only — TeleCMI `company:` room; WatConnect WhatsApp uses `connectedSocket`. */
  const [crmSocket, setCrmSocket] = useState();
  const lastActivityRef = useRef(Date.now());
  const idleLogoutTriggeredRef = useRef(false);
  // const [selectedWhatsAppSetting, setSelectedWhatsAppSetting] = useState(localStorage.getItem('selectedWhatsAppSetting') || '');
  const [deviceId, setDeviceId] = useState(() => {
    let existingId = localStorage.getItem('deviceId');
    if (!existingId) {
      existingId = uuidv4();
      localStorage.setItem('deviceId', existingId);
    }
    return existingId;
  });

  const [selectedWhatsAppSetting, setSelectedWhatsAppSetting] = useState(
    localStorage.getItem('selectedWhatsAppSetting') || ''
  );
  useEffect(() => {
    const refreshThresholdMs = 5 * 60 * 1000;

    const validateOrRefresh = async () => {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');

      if (!token && !refreshToken) {
        return;
      }

      if (!token && refreshToken) {
        const refreshed = await authApi.refreshToken();
        if (!refreshed) {
          authApi.logout();
        }
        return;
      }

      try {
        const { exp } = jwt_decode(token);
        if (!exp || exp * 1000 <= Date.now()) {
          if (refreshToken) {
            const refreshed = await authApi.refreshToken();
            if (!refreshed) {
              authApi.logout('SESSION_EXPIRED');
            }
          } else {
            authApi.logout('SESSION_EXPIRED');
          }
          return;
        }

        if (exp * 1000 - Date.now() <= refreshThresholdMs && refreshToken) {
          await authApi.refreshToken();
        }
      } catch (error) {
        console.error('Token validation error:', error);
        authApi.logout('SESSION_EXPIRED');
      }
    };

    validateOrRefresh();
    const intervalId = setInterval(validateOrRefresh, 4 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const hasEntitlements = sessionStorage.getItem('entitlements');
    if (token && !hasEntitlements) {
      authApi.fetchEntitlements();
    }
  }, []);

  useEffect(() => {
    const storedSettings = localStorage.getItem('authSettings');
    let authSettings = null;
    try {
      authSettings = storedSettings ? JSON.parse(storedSettings) : null;
    } catch (error) {
      authSettings = null;
    }

    const idleTimeoutMinutes = Number(
      authSettings?.idleTimeoutMinutes ||
      process.env.REACT_APP_IDLE_TIMEOUT_MINUTES ||
      120
    );
    if (!idleTimeoutMinutes || idleTimeoutMinutes <= 0) {
      return;
    }

    const idleTimeoutMs = idleTimeoutMinutes * 60 * 1000;
    const updateActivity = () => {
      lastActivityRef.current = Date.now();
    };
    const activityEvents = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
    ];

    activityEvents.forEach(event =>
      window.addEventListener(event, updateActivity, { passive: true })
    );

    const intervalId = setInterval(() => {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');
      if (!token && !refreshToken) {
        return;
      }
      if (idleLogoutTriggeredRef.current) {
        return;
      }
      if (Date.now() - lastActivityRef.current > idleTimeoutMs) {
        idleLogoutTriggeredRef.current = true;
        authApi.logout('IDLE_TIMEOUT');
      }
    }, 60 * 1000);

    return () => {
      activityEvents.forEach(event =>
        window.removeEventListener(event, updateActivity)
      );
      clearInterval(intervalId);
    };
  }, []);
  const mySubscriber = (msg, data) => {
    switch (msg) {
      case 'RECORD_SAVED_TOAST':
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant('success');
        ////console.log('mytopic: RECORD_SAVED_TOAST'); // add your desired log message
        break;
      case 'RECORD_ERROR_TOAST':
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant('danger');
        ////console.log('mytopic: RECORD_ERROR_TOAST'); // add your desired log message
        break;
      default:
        ////console.log('mytopic: default'); // add your desired log message
        break;
    }
  };
  const handleWhatsAppSettingChange = newSettingId => {
    console.log('new setting id->>', newSettingId);
    setSelectedWhatsAppSetting(newSettingId);
  };

  // WatConnect WhatsApp — admin.watconnect.com + /ibs/socket.io (unchanged from original).
  useEffect(() => {
    let socketInstance = null;

    const connectWatconnectSocket = () => {
      if (socketInstance) {
        socketInstance.removeAllListeners();
        socketInstance.disconnect();
        socketInstance = null;
      }

      const token = localStorage.getItem('watconnect_token');
      if (!token) {
        setConnectedSocket(undefined);
        return;
      }

      let user;
      try {
        user = jwt_decode(token);
      } catch (error) {
        console.error('WatConnect socket: invalid JWT', error);
        setConnectedSocket(undefined);
        return;
      }

      if (!localStorage.getItem('token')) {
        setUserInfo(user);
        const perm = user?.permissions?.map(obj => obj.name).join(';');
        setPermissions(perm);
      }

      const socketUrl = constants.WATCONNECT_SOCKET_URL;
      const socketPath = constants.WATCONNECT_SOCKET_PATH;

      socketInstance = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
        reconnection: true,
      });

      socketInstance.on('connect', () => {
        console.log(
          'WatConnect socket connected:',
          socketInstance.id,
          socketUrl,
          socketPath
        );
        socketInstance.emit('setup', {
          ...user,
          deviceId,
          business_number: selectedWhatsAppSetting,
        });
        setConnectedSocket(socketInstance);
      });

      socketInstance.on('connected', () => { });

      socketInstance.on('receivedwhatsappmessage', () => { });

      socketInstance.on('disconnect', reason => {
        console.warn('WatConnect socket disconnected:', reason);
      });

      socketInstance.on('connect_error', err => {
        console.error(
          'WatConnect socket error:',
          socketUrl,
          socketPath,
          err.message
        );
      });
    };

    connectWatconnectSocket();
    const onAuth = () => connectWatconnectSocket();
    window.addEventListener('ibs-auth-login', onAuth);

    return () => {
      window.removeEventListener('ibs-auth-login', onAuth);
      if (socketInstance) {
        socketInstance.removeAllListeners();
        socketInstance.disconnect();
      }
    };
  }, [deviceId, selectedWhatsAppSetting]);

  // Spark CRM / TeleCMI — same host as API, path /socket.io
  useEffect(() => {
    let socketInstance = null;

    const connectCrmSocket = () => {
      if (socketInstance) {
        socketInstance.removeAllListeners();
        socketInstance.disconnect();
        socketInstance = null;
      }

      const token = localStorage.getItem('token');
      if (!token) {
        setCrmSocket(undefined);
        return;
      }

      let user;
      try {
        user = jwt_decode(token);
      } catch (error) {
        console.error('CRM socket: invalid JWT', error);
        setCrmSocket(undefined);
        return;
      }

      setUserInfo(user);
      const perm = user?.permissions?.map(obj => obj.name).join(';');
      setPermissions(perm);

      const socketUrl = constants.API_BASE_URL;
      const socketPath = constants.SOCKET_IO_PATH || '/socket.io';

      socketInstance = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
        reconnection: true,
      });

      socketInstance.on('connect', () => {
        const payload = {
          ...user,
          deviceId,
          business_number: selectedWhatsAppSetting,
        };
        console.log('[TeleCMI socket] CRM connected', {
          socketId: socketInstance.id,
          url: socketUrl,
          path: socketPath,
          companyid: user?.companyid,
          userid: user?.id,
          setupKeys: Object.keys(payload),
        });
        socketInstance.emit('setup', payload);
        setCrmSocket(socketInstance);
      });

      socketInstance.on('connected', () => {
        console.log('[TeleCMI socket] server ack "connected"', {
          socketId: socketInstance.id,
        });
      });

      socketInstance.on('disconnect', reason => {
        console.warn('[TeleCMI socket] CRM disconnected', { reason });
      });

      socketInstance.on('connect_error', err => {
        console.error('[TeleCMI socket] CRM connect_error', {
          url: socketUrl,
          path: socketPath,
          message: err.message,
        });
      });
    };

    connectCrmSocket();
    const onAuthLogin = () => connectCrmSocket();
    window.addEventListener('ibs-auth-login', onAuthLogin);

    return () => {
      window.removeEventListener('ibs-auth-login', onAuthLogin);
      if (socketInstance) {
        socketInstance.removeAllListeners();
        socketInstance.disconnect();
      }
    };
  }, [deviceId, selectedWhatsAppSetting]);

  // useEffect(() => {
  //   console.log('Permissions:', permissions);
  //   console.log('Expected VIEW_ACCOUNT:', constants.VIEW_ACCOUNT);
  //   console.log('Expected MODIFY_ALL:', constants.MODIFY_ALL);
  //   console.log('selectedWhatsAppSetting', selectedWhatsAppSetting);
  //   console.log('constantsss', constants.API_BASE_URL);
  //   //dispatch(fetchAccounts());
  //   PubSub.subscribe('RECORD_SAVED_TOAST', mySubscriber);
  //   PubSub.subscribe('RECORD_ERROR_TOAST', mySubscriber);
  //   try {
  //     const token = localStorage.getItem('watconnect_token');
  //     if (localStorage.getItem('watconnect_token')) {
  //       let user = jwt_decode(localStorage.getItem('watconnect_token'));
  //       console.log('user-->>', user);

  //       setUserInfo(user);

  //       // var perm = user.permissions.map(function (obj) {
  //       //   return obj.name;
  //       // }).join(';')
  //       // setPermissions(perm);
  //       var perm = user.module.map(obj => obj.name).join(';');
  //       setPermissions(perm);

  //       //socket
  //       console.log(ENDPOINT);

  //       let socket = io(ENDPOINT, {
  //         // note changed URL here
  //         path: '/ibs/socket.io',
  //         transports: ['websocket'],
  //       });
  //       socket.on('connect_error', err => {
  //         console.log(`connect_error due to`, err);
  //       });
  //       console.log(socket);
  //       socket.emit('setup', {
  //         ...user,
  //         deviceId,
  //         business_number: selectedWhatsAppSetting, // or however you track business number
  //       });

  //       // socket.emit('setup', user);
  //       socket.on('connect', msg => {
  //         console.log('connected client');
  //         setConnectedSocket(socket);
  //       });
  //     }
  //     if (token) {
  //       let user = jwt_decode(localStorage.getItem('watconnect_token'));
  //       setUserInfo(user);

  //       var perm = user.permissions
  //         .map(function (obj) {
  //           return obj.name;
  //         })
  //         .join(';');
  //       setPermissions(perm);

  //       //socket
  //       console.log(ENDPOINT);

  //       let socket = io(ENDPOINT, {
  //         // note changed URL here
  //         path: '/ibs/socket.io',
  //         transports: ['websocket'],
  //       });
  //       socket.on('connect_error', err => {
  //         console.log(`connect_error due to`, err);
  //       });
  //       console.log(socket);
  //       socket.emit('setup', {
  //         ...user,
  //         deviceId,
  //         business_number: selectedWhatsAppSetting, // or however you track business number
  //       });
  //       socket.on('connect', msg => {
  //         console.log('connected client');
  //         setConnectedSocket(socket);
  //       });
  //     }
  //   } catch (error) {
  //     console.log('error', error);
  //   }

  //   console.log('working this app.jsx file!!');
  //   console.log('permissions :', permissions);
  // }, []);

  return (
    <>
      <ToastContainer className='p-3' position='top-center'>
        <Toast
          show={modalShow}
          onClose={() => setModalShow(false)}
          delay={3000}
          bg={variant}
          className='text-white'
          autohide
        >
          {variant === 'success' ? (
            <div
              className='p-1 m-1'
              style={{ backgroundColor: '#198754', color: 'white' }}
            >
              <i className='fa-regular fa-circle-check text-white mx-2'></i>
              <strong className='me-auto'>{title}</strong>
              <i
                className='fa-solid fa-xmark text-white float-right'
                style={{ float: 'right' }}
                role='button'
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          ) : (
            <div
              className='p-1 m-1'
              style={{ backgroundColor: '#DC3545', color: 'white' }}
            >
              <i className='fa-regular fa-circle-check text-white mx-2'></i>
              <strong className='me-auto'>{title}</strong>
              <i
                className='fa-solid fa-xmark text-white float-right'
                style={{ float: 'right' }}
                role='button'
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          )}

          <Toast.Body>
            {message instanceof Array ? (
              message.map(item => {
                return <span>{item.msg}</span>;
              })
            ) : message instanceof Object ? (
              <span>{message.detail}</span>
            ) : (
              <span>{message}</span>
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Router>
        <Routes>
          <Route path='/admin/login' element={<AdminLogin />} />
          <Route path='/admin' element={<AdminDashboard />}>
            <Route index element={<Navigate to='/admin/schemas' replace />} />
            <Route path='schemas' element={<AdminSchemas />} />
            <Route path='schemas/:tenantCode' element={<AdminSchemaConfig />} />
            <Route path='company/:id' element={<AdminCompanyDetail />} />
            <Route path='pricebooks' element={<AdminPricebooks />} />
            <Route path='pricebooks/:id' element={<AdminPricebookDetail />} />
            <Route path='license-types' element={<AdminLicenseTypes />} />
            <Route path='plans' element={<AdminPlans />} />
            <Route path='plans/:id' element={<AdminPlanConfig />} />
            <Route path='plans/:id/detail' element={<AdminPlanDetail />} />
            <Route path='plans/:id/licenses' element={<AdminPlanLicenses />} />
          </Route>
          <Route path='/reset-password' element={<ResetPassword />} />{' '}
          <Route path='/login' element={<Login />} />
          <Route
            path='/google-auth-callback'
            element={<GoogleAuthCallback />}
          />
          <Route
            path='/google-auth-callback'
            element={<GoogleAuthCallback />}
          />
          <Route
            path='/'
            element={
              <Main
                socket={connectedSocket}
                crmSocket={crmSocket}
                onWhatsAppSettingChange={handleWhatsAppSettingChange}
              />
            }
          >
            {/* <Route
              index
              element={
                <Home selectedWhatsAppSetting={selectedWhatsAppSetting} />
              }
            />
           */}

            <Route index element={<HomeWidget />} />
            <Route path='/changepassword' element={<ChangePassword />} />
            <Route path='/profile' element={<UserProfile />} />
            <Route path='/myprofile' element={<UserProfile />} />
            <Route path='/profile/edit' element={<ProfileEdit />} />
            <Route
              path='/setup/profile'
              element={<Navigate to='/profile' replace />}
            />
            <Route
              path='/google-calendar-sync'
              element={<GoogleCalendarSync />}
            />
            <Route path='reports/:id' element={<ReportView />} />
            <Route path='/reports' element={<ReportsListPage />} />

            <Route
              path='reports/:id'
              element={
                <>
                  <div className='wrapper'>
                    {/* <Sidebar /> */}
                    <div id='content'>
                      <ReportView />
                    </div>
                  </div>
                </>
              }
            />
            <Route
              path='/reports'
              element={
                <>
                  <div className='wrapper'>
                    {/* <Sidebar /> */}
                    <div id='content'>
                      <ReportList />
                    </div>
                  </div>
                </>
              }
            />

            <Route
              path='/reportedit/:id'
              element={
                <>
                  <div className='wrapper'>
                    {/* <Sidebar /> */}
                    <div id='content'>
                      <ReportEdit />
                    </div>
                  </div>
                </>
              }
            />

            <Route
              path='/reports/e'
              element={
                <>
                  <div className='wrapper'>
                    {/* <Sidebar /> */}
                    <div id='content'>
                      <ReportBuilder />
                    </div>
                  </div>
                </>
              }
            />

            {/* Report Builder - New Route */}
            <Route
              path='/report-builder'
              element={
                <>
                  <div className='wrapper'>
                    <div id='content'>
                      <ReportBuilder />
                    </div>
                  </div>
                </>
              }
            />
            <Route
              path='/reportbuilderpage/:reportId?'
              element={
                <>
                  <div className='wrapper'>
                    <div id='content'>
                      <ReportBuilderPage />
                    </div>
                  </div>
                </>
              }
            />

            <Route
              path='/viewreport/:reportId?'
              element={
                <>
                  <div className='wrapper'>
                    <div id='content'>
                      <ReportViewer />
                    </div>
                  </div>
                </>
              }
            />

            {/* <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/dashboards" element={<DashboardList />} />
            <Route path="dashboards/:id" element={<DashboardView />} />
            <Route path="dashboards/:id" element={<DashboardView />} />
            <Route path="dashboards/:id/e" element={<DashboardEdit />}></Route> */}

            {/* New Dashboard Manager */}
            <Route path='/dashboards' element={<DashboardManager />} />
            <Route
              path='/dashboard/:dashboardId/widgets'
              element={<WidgetManager />}
            />
            <Route
              path='/dashboard/:dashboardId/canvas'
              element={<DashboardCanvas />}
            />
            <Route
              path='/dashboard/:dashboardId/run'
              element={<DashboardCanvas isRunMode={true} />}
            />
            {/*========================================== added by muskan khan======================================= */}
            <Route path='/homewidget' element={<Navigate to='/setup/homewidget' replace />} />
            <Route path='/homewidgetbuilder' element={<HomeWidgetBuilder />} />
            <Route
              path='/watconnect/settings'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <WhatsAppSetting />
                  </div>
                </div>
              }
            />
            <Route
              path='/watconnect/templates'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Templates
                      socket={connectedSocket}
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />
            {/* Redirect user object from tab URLs to Setup */}
            <Route path='/listview/user' element={<RedirectUserList />} />
            <Route path='/listview/user/' element={<RedirectUserList />} />
            <Route
              path='/view/user/:id'
              element={<RedirectUserView />}
            />
            <Route
              path='/edit/user/:id'
              element={<RedirectUserEdit />}
            />
            <Route
              path='/edit/user'
              element={<Navigate to='/setup/users/create' replace />}
            />
            {/* Redirect mail_config object from tab URLs to Setup */}
            <Route path='/listview/mail_config' element={<RedirectMailConfigList />} />
            <Route path='/listview/mail_config/' element={<RedirectMailConfigList />} />
            <Route path='/view/mail_config/:id' element={<RedirectMailConfigView />} />
            <Route path='/edit/mail_config/:id' element={<RedirectMailConfigEdit />} />
            <Route
              path='/edit/mail_config'
              element={<Navigate to='/setup/mailconfig/create' replace />}
            />
            {/* Redirect email_template object from tab URLs to Setup */}
            <Route path='/listview/email_template' element={<RedirectEmailTemplateList />} />
            <Route path='/listview/email_template/' element={<RedirectEmailTemplateList />} />
            <Route path='/view/email_template/:id' element={<RedirectEmailTemplateView />} />
            <Route path='/edit/email_template/:id' element={<RedirectEmailTemplateEdit />} />
            <Route
              path='/edit/email_template'
              element={<Navigate to='/setup/emailtemplate/create' replace />}
            />

            <Route
              path='/view/:objectName/:id'
              element={
                <PermissionProtectedRoute action="read">
                  <div className='wrapper'>
                    <DetailView
                      socket={connectedSocket}
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </PermissionProtectedRoute>
              }
            />

            <Route
              path='/edit/:objectName/:id?/*'
              element={
                <PermissionProtectedRoute action="update">
                  <div className='wrapper'>
                    <EditView />
                  </div>
                </PermissionProtectedRoute>
              }
            />

            {/* Bulk Email Page */}
            <Route
              path='/bulk-email/:objectName'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <BulkEmailForm />
                  </div>
                </div>
              }
            />

            <Route
              path='/listview/:objectName/'
              element={
                <PermissionProtectedRoute action="read">
                  <div className='wrapper'>
                    <ListView />
                  </div>
                </PermissionProtectedRoute>
              }
            />
            <Route
              path='/search/:objectName'
              element={
                <PermissionProtectedRoute action="read">
                  <div className='wrapper'>
                    <SearchViewLayout />
                  </div>
                </PermissionProtectedRoute>
              }
            />

            <Route
              path='/template/add'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <TemplateAdd
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />
            <Route
              path='/template/view'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Templateview
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />

            <Route
              path='/watconnect/chats'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <WhatsAppMessenger
                      socket={connectedSocket}
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />
            <Route
              path='/watconnect/chatbots'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <ChatBotFlowList
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />

            <Route
              path='/watconnect/chatbot/add'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <AddChatBot
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />

            <Route
              path='/chatbot/:id/edit'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <AddChatBot
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />
            {/* campaign */}
            <Route
              path='/watconnect/campaigns'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Campaign
                      socket={connectedSocket}
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />

            <Route
              path='/campaign/add'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <CampaignAdd
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />

            <Route
              index
              element={
                <Campaign selectedWhatsAppSetting={selectedWhatsAppSetting} />
              }
            />
            <Route
              path='/campaign/add'
              element={
                <CampaignAdd
                  selectedWhatsAppSetting={selectedWhatsAppSetting}
                  userInfo={userInfo}
                />
              }
            />
            <Route path='/campaign/view/:id' element={<CampaignView />} />
            <Route
              path='/campaign/:id'
              element={
                <CampaignAdd
                  selectedWhatsAppSetting={selectedWhatsAppSetting}
                  userInfo={userInfo}
                />
              }
            />
            <Route
              path='/campaign/track/:id'
              element={
                <CampaignTracking
                  socket={connectedSocket}
                  selectedWhatsAppSetting={selectedWhatsAppSetting}
                  userInfo={userInfo}
                />
              }
            />
            {/* Group */}

            <Route
              path='/groups'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Groups
                      socket={connectedSocket}
                      selectedWhatsAppSetting={selectedWhatsAppSetting}
                    />
                  </div>
                </div>
              }
            />

            <Route path='/groups/:groupId' element={<GroupView />} />
            {/* Greeting MEssage */}
            <Route
              path='/greetingmessage'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <ResponseMessage />
                  </div>
                </div>
              }
            />

            {console.log(
              'selecselectedWhatsAppSettingtedWhatsAppSetting',
              selectedWhatsAppSetting
            )}

            {/* Invoice /billing */}
            <Route
              index
              path='/billing'
              element={
                <Billing selectedWhatsAppSetting={selectedWhatsAppSetting} />
              }
            />
            {/*========================================== added by muskan khan======================================= */}
            <Route
              path='/module'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Module />
                  </div>
                </div>
              }
            />
            <Route
              path='/plan'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Plan />
                  </div>
                </div>
              }
            />
            <Route
              path='/plan/add'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <CreatePlan />
                  </div>
                </div>
              }
            />
            <Route path='/plan/:id/e' element={<CreatePlan />} />
            <Route
              path='/addon'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Addon />
                  </div>
                </div>
              }
            />
            <Route
              path='/addon/add'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <CreateAddon />
                  </div>
                </div>
              }
            />
            <Route path='/addon/:id/e' element={<CreateAddon />} />
            <Route
              path='/company'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <CompanyList />
                  </div>
                </div>
              }
            />
            <Route
              path='/company/:id'
              element={<CompanyView tabName='Company Details' />}
            />
            <Route
              path='/company/add'
              element={<CreateCompany tabName='Create Company' />}
            />
            <Route
              path='/company/edit/:id?'
              element={<CreateCompany tabName='Create Company' />}
            />
            <Route
              path='/invoice'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <Invoices />
                  </div>
                </div>
              }
            />
            <Route index element={<Invoices tabName='Invoices' />} />
            <Route
              path='/invoice/generate/:id'
              element={<AddInvoice tabName='Invoice' />}
            />
            <Route
              path='/invoice/:id'
              element={<InvoiceView tabName='Invoice' />}
            />
            <Route
              path='/invoice/invoiceitems/:id'
              element={<InvoiceLineItem tabName='Invoice' />}
            />
            <Route
              path='/invoice/pay/:id'
              element={<AddInvoice tabName='Invoice' action='pay' />}
            />
            <Route
              path='/wallet'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <MyWallet />
                  </div>
                </div>
              }
            />
            <Route
              path='/tags'
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule='tags'
                />
              }
            >
              <Route index element={<TagList />} />
            </Route>
            <Route
              path='/calendar'
              element={
                <div className='wrapper'>
                  <div id='content'>
                    <CalendarComponent />
                  </div>
                </div>
              }
            />

            {/* Object Manager Route */}

            <Route path='/setup' element={<SetupWrapper />}>
              <Route path='objectmanager' element={<ObjectManager />} />
              <Route path='rolemanager' element={<RoleManager />} />
              <Route path='tabs' element={<TabManagerRoute />} />
              <Route path='appmanager' element={<AppManager />} />
              <Route path='homewidget' element={<HomeWidget />} />
              <Route path='scoringrule' element={<ScoringRuleManager />} />
              <Route path='webforms' element={<WebFormManager />} />
              <Route path='usergroups' element={<UserGroupManager />} />
              <Route path='preferences' element={<UserPreferences />} />
              <Route path='session_setting' element={<SessionSettingManager />} />
              <Route path='currency/master' element={<CurrencyMasterManager />} />
              <Route path='currency/exchange-rate' element={<CurrencyManager />} />
              <Route path='system_settings' element={<SystemSettingsManager />} />
              <Route path='stage_master' element={<StageMasterManager />} />
              <Route path='telecmi' element={<TelecmiSettingsManager />} />
              <Route path='users' element={<SetupUserList />} />
              <Route path='users/create' element={<SetupUserEdit />} />
              <Route path='users/:id/edit' element={<SetupUserEdit />} />
              <Route
                path='users/:id'
                element={
                  <SetupUserView
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route path='mailconfig' element={<SetupMailConfigList />} />
              <Route path='mailconfig/create' element={<SetupMailConfigEdit />} />
              <Route path='mailconfig/:id/edit' element={<SetupMailConfigEdit />} />
              <Route
                path='mailconfig/:id'
                element={
                  <SetupMailConfigView
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route path='emailtemplate' element={<SetupEmailTemplateList />} />
              <Route path='emailtemplate/create' element={<SetupEmailTemplateEdit />} />
              <Route path='emailtemplate/:id/edit' element={<SetupEmailTemplateEdit />} />
              <Route
                path='emailtemplate/:id'
                element={
                  <SetupEmailTemplateView
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path='assignmentrule'
                element={<AssignmentRuleManager />}
              />
              <Route
                path='actions'
                element={<ActionManager show={true} onHide={() => { }} />}
              />
              <Route
                path=':objectName/actions'
                element={<ActionManager show={true} onHide={() => { }} />}
              />

              <Route
                path='permission/:id/bulk-edit'
                element={<PermissionBulkEdit />}
              />

              <Route
                path='permission/:id/edit/:permissionId'
                element={<PermissionEdit />}
              />

              <Route path='permission/:id' element={<PermissionList />} />

              {/* Report Builder in Setup */}
              <Route path='report-builder' element={<ReportBuilder />} />

              {/* Workflow Manager in Setup */}
              <Route path='workflows' element={<WorkflowList />} />
              <Route
                path='workflows/create'
                element={
                  <div className='wrapper'>
                    <div id='content'>
                      <WorkflowEditForm />
                    </div>
                  </div>
                }
              />

              {/* Search View Manager in Setup */}
              <Route path='searchviews' element={<SearchViewManager />} />
              <Route
                path='workflows/:id/edit'
                element={
                  <div className='wrapper'>
                    <div id='content'>
                      <WorkflowEditForm />
                    </div>
                  </div>
                }
              />
              <Route
                path='workflows/:id'
                element={
                  <div className='wrapper'>
                    <div id='content'>
                      <WorkflowEditForm />
                    </div>
                  </div>
                }
              />
            </Route>
          </Route>

          {/* Error Pages */}
          <Route path="/access-denied" element={<AccessDenied />} />

          {/* 404 - Catch all unmatched routes */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
